import atlas, { data as AtlasData } from "azure-maps-control";

import { translationService } from "../../../services/translation/TranslationService";
import { ResetDefaultZoom } from "../../svg/svgImageList";
import {
  CardinalPoints,
  CenterAndZoom,
  addPaddingToBoundingCardinalPoints,
  instanceOfCardinalPoints,
  instanceOfCenterAndZoom,
} from "../../../helpers/MapHelpers";
import "../SewerObjectsMap.scss";

export class BringDataIntoViewControl implements atlas.Control {
  private container: HTMLElement | undefined;
  private icon: Element | undefined;
  private button: HTMLButtonElement | undefined;
  private map: atlas.Map | undefined;

  public onAdd(map: atlas.Map): HTMLElement {
    this.map = map;

    const tooltip = translationService.translate("ViewSewerObjectsOnMap.resetZoomToDefault");

    this.container = document.createElement("div");
    this.container.classList.add("azure-maps-control-container");

    this.button = document.createElement("button");
    this.button.classList.add("atlas-map-button");
    this.button.setAttribute("title", tooltip);
    this.button.addEventListener("click", () =>
      this.handleClick(this.getBoundsAfterResetZoom(this.map!))
    );

    this.icon = document.createElement("img");
    this.icon.setAttribute("src", ResetDefaultZoom);

    this.button.appendChild(this.icon);
    this.container.appendChild(this.button);
    return this.container;
  }

  public onRemove(): void {
    if (this.container) {
      this.container.remove();
      this.container = undefined;
    }
    this.map = undefined;
  }

  public handleClick(newBounds: CardinalPoints | CenterAndZoom | null) {
    if (!newBounds) return;

    if (instanceOfCardinalPoints(newBounds)) {
      this.map?.setCamera({
        bounds: Object.values(newBounds),
      });
    }

    if (instanceOfCenterAndZoom(newBounds)) {
      this.map?.setCamera({
        zoom: newBounds.zoom,
        center: Object.values(newBounds.center),
      });
    }
  }

  public getBoundsAfterResetZoom(map: atlas.Map): CardinalPoints | CenterAndZoom | null {
    let data: atlas.data.Feature<atlas.data.Geometry, any>[] = [];

    for (const source of map.sources["sources"].values()) {
      if (source.toJson) {
        data = data.concat((source as atlas.source.DataSource).toJson().features);
      }
    }

    if (!data.length) return null;
    let bounds = AtlasData.BoundingBox.fromData(data);
    return addPaddingToBoundingCardinalPoints(
      {
        west: bounds[0],
        south: bounds[1],
        east: bounds[2],
        north: bounds[3],
      },
      4
    );
  }
}
